// Static occasion calendar used for the occasion-aware hero line.
// Fixed-date and nth-weekday holidays only, no API needed.

function nthSundayOf(year, monthIdx, n) {
  const first = new Date(year, monthIdx, 1);
  const offset = (7 - first.getDay()) % 7; // days until first Sunday
  return new Date(year, monthIdx, 1 + offset + (n - 1) * 7);
}

function occasionsForYear(year) {
  return [
    { name: "Valentine's Day", date: new Date(year, 1, 14) },
    { name: "Mother's Day", date: nthSundayOf(year, 4, 2) },
    { name: "Father's Day", date: nthSundayOf(year, 5, 3) },
    { name: 'Halloween', date: new Date(year, 9, 31) },
    { name: 'Christmas', date: new Date(year, 11, 25) },
  ];
}

/**
 * Returns the next upcoming gift occasion as { name, days } where `days`
 * is whole days from today (0 = today). Always resolves, rolls into the
 * next year after Christmas.
 */
export function getNextOccasion(now = new Date()) {
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const candidates = [
    ...occasionsForYear(today.getFullYear()),
    ...occasionsForYear(today.getFullYear() + 1),
  ];
  const next = candidates
    .filter((o) => o.date >= today)
    .sort((a, b) => a.date - b.date)[0];
  const days = Math.round((next.date - today) / 86400000);
  return { name: next.name, days };
}
